import { render, staticRenderFns } from "./AddItemPage.vue?vue&type=template&id=3d2f7e2b&scoped=true&"
import script from "./AddItemPage.vue?vue&type=script&lang=js&"
export * from "./AddItemPage.vue?vue&type=script&lang=js&"
import style0 from "./AddItemPage.vue?vue&type=style&index=0&id=3d2f7e2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f7e2b",
  null
  
)

export default component.exports